import PropTypes from 'prop-types';
import React from 'react';
import Inspector from 'react-inspector';
import { connect } from 'react-redux';
import { Route, Switch, withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { BaseComponent } from '../../../components/BaseComponent';
import { HBox, VBox } from '../../../components/Box';
import { Button } from '../../../components/Buttons';
import { Content } from '../../../components/Content';
import { Loader } from '../../../components/Loader';
import { selectWorks } from '../../Api/selectors';
import { exportData, fetchUser } from '../actions';
import { BasicDetails } from '../components/BasicDetails';
import { UserPropertiesEditor } from '../components/UserPropertiesEditor';
import { REQUEST_USER } from '../constants';
import { selectUser, selectUsers } from '../selectors';

const Container = styled.div`
  .content {
    display: inline-block;
    width: 100%;
  }
`;

const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0 4px;
`;

/* eslint-disable react/prefer-stateless-function */
class UserDetailsVarsComp extends BaseComponent {
  constructor(props) {
    super(props, {});
  }

  componentDidMount() {
    debugger;
  }

  get user() {
    return this.props.user;
  }

  handleExportData = async () => {
    const { exportData } = this.props;

    console.log(this.user.id);
    if (!this.user.id) {
      return;
    }
    try {
      const response = await exportData(this.user.id);

      return response;
    } catch (e) {
      console.error(e);
    }
  };

  render() {
    if (this.props.work) return <Loader small />;
    if (!this.user) return 'x';

    return (
      <Container>
        {/* <HeaderContainer>
          <h3>{this.user.name}</h3>
          <Button small block onClick={this.handleExportData}>
            Hegla Export
          </Button>
        </HeaderContainer> */}
        <Content className="content">
          <VBox>
            <HBox left>
              <Button small inline onClick={this.tofn(`/users/${this.user.id}`)}>
                {this.lbl('user.details.title')}
              </Button>
              <Button small inline onClick={this.tofn(`/users/${this.user.id}/documents`)}>
                {this.lbl('user.details.documents.title')}
              </Button>
            </HBox>
            <HBox>
              <UserPropertiesEditor user={this.props.user} />
              <Inspector data={this.props.user} expandLevel={1}></Inspector>
            </HBox>
          </VBox>
        </Content>
      </Container>
    );
  }
}

UserDetailsVarsComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    user: selectUser(ownProps.user_id),
    work: selectWorks([REQUEST_USER]),
    users: selectUsers(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    // exportData: (userId, callback) => {
    //   dispatch(exportData(userId, callback));
    // },
  };
}

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export const UserDetailsVars = compose(
  withConnect,
  withRouter,
)(UserDetailsVarsComp);
